import { CategorySelectionType } from './categoryTreeSlice';
import { css, styled } from 'styled-components';
import { COLORS } from '../../../styles/style';
import { NavLink } from 'react-router';
import { computeRemSize } from '@ydistri/theme';
import { CategoryTreePresentationMode } from './CategoryTreeTypes';

interface TreeNodeProps {
  $level: number;
  $selectionType: CategorySelectionType | undefined;
  $isOpened: boolean;
  $isLastLevel?: boolean;
  $disabled?: boolean;
  $presentationMode?: CategoryTreePresentationMode;
}

interface TreeLeafTitleProps {
  $disabled?: boolean;
  $presentationMode?: CategoryTreePresentationMode;
}

export const getTextColor = (
  disabled: boolean | undefined = false,
  presentationMode:
    | CategoryTreePresentationMode
    | undefined = CategoryTreePresentationMode.CONFIGURATION,
): string => {
  if (
    (presentationMode === CategoryTreePresentationMode.CONFIGURATION ||
      presentationMode === CategoryTreePresentationMode.CALCULATION) &&
    disabled
  ) {
    return COLORS.GREY;
  }
  return 'black';
};

export const TreeLeafTitle = styled.span<TreeLeafTitleProps>`
  flex-grow: 1;
  padding: 0.4rem;
  border-radius: 0.4rem;
  position: relative;
  color: ${p => getTextColor(p.$disabled, p.$presentationMode)};

  &:hover {
    color: ${p => getTextColor(p.$disabled, p.$presentationMode)};
  }

  transition: 0.3s all;
`;

export const TreeLeafWrapper = styled(NavLink)<TreeNodeProps>`
  width: 100%;
  display: flex;
  cursor: pointer;
  font-size: ${computeRemSize(14)};
  padding: 0.5rem 0.7rem 0.5rem 0.5rem;

  color: ${p => getTextColor(p.$disabled, p.$presentationMode)};


  ${p =>
    p.$level === 0 &&
    css`
      border-top: ${computeRemSize(1)} solid ${COLORS.GREY_BORDER};
      padding-left: 0.25rem;
    `}

  ${p =>
    (p.$level === 0 || p.$level === 1) &&
    css`
      font-weight: bold;
      border-bottom: ${computeRemSize(1)} solid ${COLORS.GREY_BORDER};
    `}


  ${p =>
    p.$level > 1 &&
    css`
      font-size: 1rem;
      font-weight: 400;
      border-bottom: ${computeRemSize(1)} solid ${COLORS.GREY_BORDER};
    `}

  border-left: ${computeRemSize(3)} solid ${p => {
    if (p.$selectionType === 'exact' || (p.$selectionType === 'parent' && p.$level > 0))
      return COLORS.PRIMARY;
    else return 'transparent';
  }};

  background-color: ${p => {
    if (p.$selectionType === 'exact') return p.theme.item.selected.backgroundColor;
    else return 'initial';
  }};

  &:hover {
    background-color: ${p => p.theme.item.hovered.backgroundColor};
    color: ${p => getTextColor(p.$disabled, p.$presentationMode)};
`;
